export default __webpack_public_path__ + "static/media/solboy.ebb5c5e9.mp4";